import * as yup from 'yup';
import { PatchModel } from 'utils';
import { Admin, API_USER_EXPERT_PROFILES, Member, VisitorModel } from './models';
import { api } from 'AurionCR/components';
import { isDateStringOrNumber } from 'utils/yup-rules';
import { InferType } from 'yup';

export * from './models';

export const schemaUserExpertProfile = yup.object({
  appIdentityUserID: yup.string().required('rule-required').default(''),

  userPhoto: yup.string().default(''),
  firstName: yup.string().required('rule-required').default(''),
  lastName: yup.string().required('rule-required').default(''),
  startDate: yup
    .mixed()
    .required('rule-required')
    .test('is-date', 'invalid-date-format', isDateStringOrNumber)
    .default(''),
  fullNameEnglish: yup.string().default(''),
  userExpertStatusID: yup.string().required('rule-required').default(''),

  email: yup.string().default(''),
  mobilePhone: yup.string().default(''),
  industryID: yup.string().required('rule-required').default(''),
  fieldOfOccupationID: yup.string().required('rule-required').default(''),
  cityID: yup.string().required('rule-required').default(''),

  companyName: yup.string().default(''),
  position: yup.string().default(''),
  languageID: yup.string().required('rule-required').default(''),
  isAllowSMS: yup.boolean().default(false),
  isActive: yup.boolean().default(false),
  ipAddress: yup.string().default(''),
  location: yup.string().default(''),
  deviceType: yup.string().default(''),

  description: yup.string().default(''),
});

export type UserExpertProfileType = InferType<typeof schemaUserExpertProfile>;

class Service {
  createVisitor(data: Partial<Member>) {
    return api.post(API_USER_EXPERT_PROFILES.POST_VISITOR, data);
  }

  patch(data: PatchModel<Member, 'appIdentityUserID'>) {
    const patchData: Partial<Member> = {
      fieldOfOccupationID: data.fieldOfOccupationID,
      isAllowSMS: data.isAllowSMS,
      isActive: data.isActive,
      expertTypeID: data.expertTypeID,
      userExpertStatusID: data.userExpertStatusID,
      firstName: data.firstName,
      lastName: data.lastName,
      position: data.position,
      languageID: data.languageID,
    };
    return api.patch(API_USER_EXPERT_PROFILES.PATCH(data), patchData);
  }

  patchVisitor(data: PatchModel<VisitorModel, 'appIdentityUserID'>) {
    const patchData: Partial<VisitorModel> = {
      fieldOfOccupationID: data.fieldOfOccupationID,
      firstName: data.firstName,
      lastName: data.lastName,
      userPhoto: data.userPhoto,
      position: data.position,
      userExpertProfileTags: data.userExpertProfileTags,
      companyName: data.companyName,
      fieldOfOccupation: data.fieldOfOccupation,
      cityID: data.cityID,
      industryID: data.industryID,
      userExpertStatusID: data.userExpertStatusID,
      userExpertProfileSpeakLanguages: data.userExpertProfileSpeakLanguages,
    };
    return api.patch(API_USER_EXPERT_PROFILES.PATCH(data), patchData);
  }

  patchAdmin(data: PatchModel<Admin, 'appIdentityUserID'>) {
    const patchData: Partial<Admin> = {
      fieldOfOccupationID: data.fieldOfOccupationID,
      firstName: data.firstName,
      lastName: data.lastName,
      position: data.position,
      companyName: data.companyName,
      userStatusID: data.userStatusID,
    };
    return api.patch(API_USER_EXPERT_PROFILES.PATCH(data), patchData);
  }

  async resetUsers() {
    return api.delete(API_USER_EXPERT_PROFILES.RESET);
  }
}

export const ServiceUserExpertProfiles = new Service();
